import { render, staticRenderFns } from "./SalesListHeader.vue?vue&type=template&id=96872c0a"
import script from "./SalesListHeader.vue?vue&type=script&lang=js"
export * from "./SalesListHeader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports